@if (isLoading() || isSuccess() || isError()) {
  <div class="modal d-block" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content text-center py-5 px-4">
        
        @if (!isSuccess() && !isError()) {
          <div class="spinner-border text-primary mb-3 mx-auto">
            <span class="visually-hidden">Loading...</span>
          </div>
          <h5 class="mb-2">{{ loadingTitle() }}</h5>
          <p class="text-muted mb-0">{{ loadingMessage() }}</p>
        }

        @if (isSuccess()) {
          <h5 class="mb-3 text-success">{{ successTitle() }}</h5>
          <p class="text-muted mb-0" [innerHTML]="successMessage()"></p>
        }

        @if (isError()) {
          <h5 class="mb-3 text-danger">{{ errorTitle() }}</h5>
          <p class="text-muted mb-0" [innerHTML]="errorMessage()"></p>
        }

      </div>
    </div>
  </div>
  <div class="modal-backdrop show"></div>
}